// extracted by mini-css-extract-plugin
export var cancelButton = "_p5-5";
export var content = "_p5-3";
export var createButton = "_p5-6";
export var drawerContainer = "_p5-0";
export var footer = "_p5-2";
export var header = "_p5-1";
export var orderFormColumn = "_p5-4";